import React, { useState, useRef, useEffect } from "react";
import Dict from './assets/dict.png'
import DictClick from './assets/dictclick.png'
import { optionOpenAtom, optionModeCloseAtom, optionModeRestAtom, optionSharpAtom } from "../../../../../store";
import { useRecoilState } from "recoil";
import { FiCheck } from "react-icons/fi";
import { Annotation } from '../Annotation'
import { useTranslation } from "react-i18next";



const Option = ({ optionChange, setOptionChange, setAdvOption, advOption }) => {
    const { t } = useTranslation();
    const [restValue, setRestValue] = useState(false)
    const [initRestValue, setInitRestValue] = useState(advOption['rest'].value)
    const [sharpValue, setSharpValue] = useState(false)
    const [initSharpValue,] = useState(advOption['sharp'].value+5)
    const [cfgValue, setCfgValue] = useState(false)
    const [initCfgValue,] = useState(advOption['cfg'].value)
    const [stepValue, setStepValue] = useState(false)
    const [initSteptValue,] = useState(advOption['step'].value-10)
    const [, setDraging] = useState(false)
    const [dictCheck, setDictCheck] = useState(false)
    const [modeCheck, setModeCheck] = useState(advOption['rest'].value?false:true)
    const [seed, setSeed] = useState(-1)
    const [optionOpen,] = useRecoilState(optionOpenAtom)
    const [optionModeClose,] = useRecoilState(optionModeCloseAtom)
    const [optionModeRest,] = useRecoilState(optionModeRestAtom)
    const [optionSharp, ] = useRecoilState(optionSharpAtom)
    useEffect(() => {
        const preAdvOption = JSON.parse(JSON.stringify(advOption))
        preAdvOption.rest = {
            value: restValue
        }
        setAdvOption(preAdvOption)
    }, [restValue])

    useEffect(() => {
        const preAdvOption = JSON.parse(JSON.stringify(advOption))
        preAdvOption.cfg = {
            value: cfgValue
        }
        setAdvOption(preAdvOption)
    }, [cfgValue])

    useEffect(() => {
        const preAdvOption = JSON.parse(JSON.stringify(advOption))
        preAdvOption.step = {
            value: stepValue + 10
        }
        setAdvOption(preAdvOption)
    }, [stepValue])

    useEffect(() => {
        const preAdvOption = JSON.parse(JSON.stringify(advOption))
        preAdvOption.sharp = {
            value: sharpValue - 5
        }
        setAdvOption(preAdvOption)
    }, [sharpValue])

    useEffect(()=>{
        if(optionModeRest){
            const preAdvOption = JSON.parse(JSON.stringify(advOption))
             preAdvOption.rest = {
                value: 0
            }
            setAdvOption(preAdvOption)
        }else{
            const preAdvOption = JSON.parse(JSON.stringify(advOption))
             preAdvOption.rest = {
                value: false
            }
            setAdvOption(preAdvOption)
        }
    },[optionModeRest])

    useEffect(() => {
        if (seed !== -1) {
            const preAdvOption = JSON.parse(JSON.stringify(advOption))
            preAdvOption.enable = {
                status: true
            }
            preAdvOption.seed = {
                value: seed
            }
            setAdvOption(preAdvOption)
        }
    }, [seed])

    const changeSeed = (e) => {
        if (e.target && e.target.value != -1) {
            setOptionChange(true)
            if (e.target.value >= 0 && e.target.value <= 65535) {
                setSeed(e.target.value)
            } else if (e.target.value > 65535) {
                setSeed(65535)
            }
        } else {
            setSeed(-1)
        }
    }

    const rdSeed = () => {
        setDictCheck(true)
        setOptionChange(true)
        const min = 0
        const max = 65535
        const num = Math.floor(Math.random() * (max - min + 1) + min)
        setSeed(num)
        setTimeout(() => {
            setDictCheck(false)
        }, 400)
    }

    const changePrompt = (e) => {
        const preAdvOption = JSON.parse(JSON.stringify(advOption))
        preAdvOption.enable = {
            status: true
        }
        preAdvOption.negative_prompt = {
            value: e.target.value
        }
        setAdvOption(preAdvOption)
    }

    return (
        <div id='rodinOption' className={`absolute z-[9999] [transition:all_0.3s_ease] bg-white right-0 top-6 lg:top-8 [@media_(min-height:1400px)]:top-12 rounded-lg [@media_(min-height:1400px)]:rounded-xl text-left p-2 [@media_(min-height:1400px)]:p-4 [box-shadow:0px_0px_12px_0px_rgba(0,0,0,0.15)] ${optionOpen ? ' visible opacity-100' : ' invisible opacity-0'}`}>
            <div className='bg-[#F8F8F8] min-w-[250px] h-full gap-2 [@media_(min-height:1400px)]:gap-3 flex flex-col justify-between rounded-lg [@media_(min-height:1400px)]:rounded-2xl p-3 [@media_(min-height:1400px)]:p-5 [fontSize:var(--midFs)] font-[Arial] font-bold'>
                <div className='flex flex-row items-center justify-between gap-[2rem] [@media_(min-height:1400px)]:gap-[3rem] whitespace-nowrap'>
                    <span className='[fontSize:var(--lgFs)] text-[#888888]'>{t('OPTION_ADVANCED_OPTIONS')}</span>
                    <div onClick={() => {
                        // setOptionInit(true)
                        const preAdvOption = JSON.parse(JSON.stringify(advOption))
                        if (!optionChange) {
                            preAdvOption.enable = {
                                status: true
                            }
                        } else {
                            preAdvOption.enable = {
                                status: false
                            }
                        }
                        setAdvOption(preAdvOption)
                        setOptionChange((old) => !old)
                    }}
                        className='flex flex-row gap-1 items-center cursor-pointer'>
                        <div className={`aspect-square w-[calc(var(--smFs)-2px)] [@media_(min-height:1400px)]:w-[calc(var(--smFs)-6px)] [@media_(min-height:1400px)]:mt-[2px] rounded-sm border-[1px] relative cursor-pointer ${optionChange ? 'border-[rgba(74,0,224,1)]' : 'border-black'}`} />
                        {optionChange && <div className='absolute mt-[1px] [@media_(min-height:1400px)]:mt-[3px]'><FiCheck className="w-[calc(var(--smFs)-2px)] [@media_(min-height:1400px)]:w-[calc(var(--smFs)-6px)] text-[rgba(74,0,224,1)]" /></div>}
                        <span className='[fontSize:var(--smFs)]  text-[#666666] '>{t('OPTION_ENABLE')}</span>
                    </div>
                </div>
                <div className='mt-1 flex flex-row items-center justify-between'>
                    <span className='flex flex-row items-center gap-[1px] z-[9999]'>{t('OPTION_SEED')}<Annotation text={t('RODIN_GENERTAE_BOARD_OPTION_SEED')} /></span>
                    <div className='flex flex-row items-center justify-end gap-1 [@media_(min-height:1400px)]:gap-2 w-[50%] h-full'>
                        <input onChange={changeSeed} value={seed} className={`w-[60%]  px-2  text-center ${optionChange ? 'text-[#7F5BC8]' : 'text-[#999999]'}   py-[0.2rem] [@media_(min-height:1400px)]:py-[0.3rem] bg-[#E8E8E8] rounded`} />
                        <div onClick={rdSeed} className={`${dictCheck && 'animate-dict-spin'} h-full aspect-square cursor-pointer p-[0.3rem] [@media_(min-height:1400px)]:p-[0.7rem] bg-[#E8E8E8] rounded-full flex justify-center items-center`}>
                            <img className={`w-[80%] [@media_(min-height:1400px)]:w-[100%] aspect-square`} src={dictCheck ? DictClick : Dict} />
                        </div>
                    </div>
                </div>
                {!optionModeClose && <div className='flex flex-row items-center justify-between mt-[0.15rem] [@media_(min-height:1400px)]:mt-[0.3rem]'>
                    <span className='flex flex-row items-center gap-[1px] z-[9999]'>{t('OPTION_MODE')}<Annotation text={t('RODIN_GENERTAE_BOARD_OPTION_MODE')} /></span>
                    <div className={`flex flex-row cursor-pointer relative [fontSize:var(--smFs)] text-[#888888] items-center bg-[#D9D9D9] border-[#EEEEEE] border-[0.2rem] [@media_(min-height:1400px)]:border-[0.3rem] rounded-3xl`}>
                        <span onClick={() => {
                            setOptionChange(true)
                            setModeCheck(true)
                            setRestValue(false)
                            setInitRestValue(0)
                            const preAdvOption = JSON.parse(JSON.stringify(advOption))
                            preAdvOption.enable = {
                                status: true
                            }
                            preAdvOption.rest = {
                                value: false
                            }
                            setAdvOption(preAdvOption)
                        }} className={`py-[0.2rem] [@media_(min-height:1400px)]:py-[0.4rem] px-4 [@media_(min-height:1400px)]:px-6 relative text-center z-10 leading-[var(--smFs)] [transition:all_0.3s_ease] ${modeCheck ? optionChange ? 'text-[#4A00E0]' : 'text-[#888888]' : 'text-[#888888]'}`}>{t('OPTION_MODE_RECON')}</span>
                        <span onClick={() => {
                            setOptionChange(true)
                            setModeCheck(false)
                            setRestValue(0)
                            setInitRestValue(0)
                            const preAdvOption = JSON.parse(JSON.stringify(advOption))
                            preAdvOption.enable = {
                                status: true
                            }
                            preAdvOption.rest = {
                                value: 0
                            }
                            setAdvOption(preAdvOption)
                        }} className={`z-10 py-[0.2rem] [@media_(min-height:1400px)]:py-[0.4rem] px-4 [@media_(min-height:1400px)]:px-6  relative [transition:all_0.3s_ease] ${!modeCheck ? optionChange ? 'text-[#4A00E0]' : 'text-[#888888]' : 'text-[#888888]'}`}>{t('OPTION_MODE_REST')}</span>
                        <span className={`absolute z-0 h-[95%] ${optionChange ? 'bg-[#E6E0F9] border-[#4A00E0]' : 'bg-[#CDCDCD] border-[#999999]'} ${modeCheck && 'animate-mode-icon'} ${!modeCheck && 'animate-remode-icon'}  rounded-3xl border-[1px] ${modeCheck ? 'left-0 w-[54%]' : 'right-0 w-[46%]'}`}></span>
                    </div>
                </div>}
                <div className={`[transition:height_0.3s_ease,opacity_0.3s_ease] ${!modeCheck ? 'mt-1 w-[100%] h-6 [@media_(min-height:1400px)]:h-8 visible opacity-100' : 'mt-0 w-0 h-0 invisible opacity-0'} `}>
                    <Slider
                        name='mode'
                        value={restValue}
                        setValue={setRestValue}
                        maxRange={5}
                        initialValue={initRestValue}
                        setDraging={setDraging}
                        advOption={advOption}
                        setAdvOption={setAdvOption}
                        setOptionChange={setOptionChange}
                        optionChange={optionChange}
                        init={!modeCheck} />
                </div>
                {!optionSharp && <div className='z-[9999]'>
                    <span className='flex flex-row items-center gap-[1px] z-[9999]'>{t('OPTION_SHARP')}</span>
                    <div className='mt-1 w-[100%]'>
                        <Slider
                            name='sharp'
                            value={sharpValue}
                            setValue={setSharpValue}
                            maxRange={10}
                            initialValue={initSharpValue}
                            setDraging={setDraging}
                            advOption={advOption}
                            setAdvOption={setAdvOption}
                            setOptionChange={setOptionChange}
                            optionChange={optionChange} />
                    </div>
                </div>}
                <div className='z-[9999]'>
                    <span className='flex flex-row items-center gap-[1px] z-[9999]'>{t('OPTION_CFG')}<Annotation text={t('RODIN_GENERTAE_BOARD_OPTION_CFG')} /></span>
                    <div className='mt-1 w-[100%]'>
                        <Slider
                            name='cfg'
                            value={cfgValue}
                            setValue={setCfgValue}
                            maxRange={15}
                            initialValue={initCfgValue}
                            setDraging={setDraging}
                            advOption={advOption}
                            setAdvOption={setAdvOption}
                            setOptionChange={setOptionChange}
                            optionChange={optionChange} />
                    </div>
                </div>
                <div className='z-[9999]'>
                    <span className='flex flex-row items-center gap-[1px] z-[9999]'>{t('OPTION_STEP')}<Annotation text={t('RODIN_GENERTAE_BOARD_OPTION_STEP')} /></span>
                    <div className='mt-1 w-[100%]'>
                        <Slider
                            name='step'
                            value={stepValue}
                            setValue={setStepValue}
                            maxRange={90}
                            initialValue={initSteptValue}
                            setDraging={setDraging}
                            advOption={advOption}
                            setAdvOption={setAdvOption}
                            setOptionChange={setOptionChange}
                            optionChange={optionChange} />
                    </div>
                </div>
                <div className='z-[9999]'>
                    <span className='flex flex-row items-center gap-[1px] z-[9999]'>{t('OPTION_PROMPT')}<Annotation text={t('RODIN_GENERTAE_BOARD_OPTION_PROMPT')} /></span>
                    <div className='mt-1 p-2 pb-1 [@media_(min-height:1400px)]:p-4 [@media_(min-height:1400px)]:pb-3 w-full bg-white rounded'>
                        <textarea onChange={changePrompt} value={advOption['negative_prompt'].value?advOption['negative_prompt'].value:''} rows="4" className={`[fontSize:var(--smFs)] leading-[var(--midFs)] ${optionChange ? 'text-[#1E1E1E]' : 'text-[#999]'} font-medium font-[Arial-Regular] w-full bg-white focus:border-white`}></textarea>
                    </div>
                </div>
            </div>
        </div>
    )
}

const Slider = React.memo(({ name, value, setValue, maxRange, setDraging, initialValue, init, optionChange, setOptionChange, setAdvOption, advOption }) => {
    const [position, setPosition] = useState(initialValue);
    const rangeRef = useRef(null);
    const knobRef = useRef(null);
    useEffect(() => {
        if (init) {
            setPosition(initialValue / maxRange * (rangeRef.current.clientWidth - knobRef.current.clientWidth))
            setValue(initialValue)
        }
    }, [init])

    useEffect(() => {
        if (rangeRef.current && knobRef.current) {
            setPosition(initialValue / maxRange * (rangeRef.current.clientWidth - knobRef.current.clientWidth))
            setValue(initialValue)
        }
    }, [rangeRef, knobRef]);

    function roundToNearestHalf(number) {
        if (name === 'cfg' || name==='sharp') {
            return Math.floor(number) + ((Number(number.toFixed(1)) - Math.floor(number)) / 5 > 0.1 ? 0.5 : 0);
        } else {
            return Math.round(number);
        }
    }

    const handleClickPosition = (e) => {
        const preAdvOption = JSON.parse(JSON.stringify(advOption))
        preAdvOption.enable = {
            status: true
        }
        setAdvOption(preAdvOption)
        setDraging(true)
        setOptionChange(true)
        const rangedom = rangeRef.current
        const knobdom = knobRef.current
        const totalWidth = rangedom.clientWidth - knobdom.clientWidth
        const left = rangedom.getBoundingClientRect().left
        const startX = e.clientX;
        let diffX = startX - left
        if (diffX <= 0) {
            diffX = 0
        }
        if (diffX >= (rangedom.clientWidth - knobdom.clientWidth)) {
            diffX = (rangedom.clientWidth - knobdom.clientWidth)
        }
        setPosition(diffX - knobdom.clientWidth / 2)
        const count = roundToNearestHalf((diffX) / totalWidth * maxRange, 1)
        if (count > maxRange) {
            setValue(maxRange)
        } else if ((name === 'mode' || name === 'step' || name==='sharp') && count < 0) {
            setValue(0)
        } else if (name !== 'mode' && name !== 'step' && name !== 'sharp' && count < 1) {
            setValue(1)
        } else {
            setValue(count)
        }
        document.onmousemove = (e) => {
            setDraging(true)
            e.stopPropagation()
            const endX = e.clientX;
            let diffX = startX - left + endX - startX
            if (diffX <= 0) {
                diffX = 0
            }
            if (diffX >= (rangedom.clientWidth - knobdom.clientWidth)) {
                diffX = (rangedom.clientWidth - knobdom.clientWidth)
            }
            setPosition(diffX - knobdom.clientWidth / 2)
            const count = roundToNearestHalf(diffX / totalWidth * maxRange, 1)
            if (count > maxRange) {
                setValue(maxRange)
            } else if ((name === 'mode' || name === 'step' || name==='sharp') && count < 0) {
                setValue(0)
            } else if (name !== 'mode' && name !== 'step' && name !== 'sharp' && count < 1) {
                setValue(1)
            } else {
                setValue(count)
            }
        }
        document.onmouseup = function () {
            setDraging(false)
            e.stopPropagation()
            document.onmousemove = null;
            document.onmouseup = null;
        };
    }

    const handleStart = (operate, e) => {
        const preAdvOption = JSON.parse(JSON.stringify(advOption))
        preAdvOption.enable = {
            status: true
        }
        setAdvOption(preAdvOption)
        e.stopPropagation()
        setOptionChange(true)
        setDraging(true)
        if (operate === 'mouse' && e.button !== 0) return;
        if (operate === 'touch' && e.touches.length !== 1) return;
        if (e.button !== 0) return

        const rangedom = rangeRef.current
        const knobdom = knobRef.current
        const totalWidth = rangedom.clientWidth - knobdom.clientWidth
        const startX = operate === 'mouse' ? e.clientX + 12 : e.touches[0].clientX + 12;
        const selfXPosition = knobdom.offsetLeft
        const handleMove = (e) => {
            setDraging(true)
            e.stopPropagation()
            const endX = operate === 'mouse' ? e.clientX : e.touches[0].clientX;
            let diffX = selfXPosition + endX - startX
            if (diffX <= 0) {
                diffX = 0
            }
            if (diffX >= (rangedom.clientWidth - knobdom.clientWidth)) {
                diffX = (rangedom.clientWidth - knobdom.clientWidth)
            }

            setPosition(diffX)
            const count = roundToNearestHalf(diffX / totalWidth * maxRange, 1)
            if (count > maxRange) {
                setValue(maxRange)
            } else if ((name === 'mode' || name === 'step' || name==='sharp') && count < 0) {
                setValue(0)
            } else if (name !== 'mode' && name !== 'step' && name !== 'sharp' && count < 1) {
                setValue(1)
            } else {
                setValue(count)
            }
        }
        const handleEnd = () => {
            setDraging(false)
            if (operate === 'mouse') {
                document.removeEventListener('mousemove', handleMove);
                document.removeEventListener('mouseup', handleEnd);
            } else {
                document.removeEventListener('touchmove', handleMove);
                document.removeEventListener('touchend', handleEnd);
                document.removeEventListener('touchcancel', handleEnd);
            }
        }
        if (operate === 'mouse') {
            document.addEventListener('mousemove', handleMove);
            document.addEventListener('mouseup', handleEnd);
        } else {
            document.addEventListener('touchmove', handleMove);
            document.addEventListener('touchend', handleEnd);
            document.addEventListener('touchcancel', handleEnd);
        }
    }
    return (
        <div className='relative w-full pl-[0] pr-[0] py-[2px] flex items-center'>
            <div className='relative h-[20px] p-[3px] [@media_(min-height:1400px)]:h-[30px] rounded-[10px] bg-[#eee] w-[85%] ' onPointerDown={handleClickPosition} ref={rangeRef}>
                <div className='relative h-full rounded-[12px] bg-[#fff] w-full'>
                    {[...Array((name === 'cfg' ? 30 : (name === 'step' || name==='sharp') ? 20 : 10) + 1)].map((_, index) => (
                        <div
                            style={{
                                left: `${index * (name === 'cfg' ? 3.3 : (name === 'step' || name==='sharp') ? 5 : 10)}%`,
                                display: `${index % 2 === 0 ? 'none' : 'block'}`,
                                background: `${index <= (name === 'step'? value / 10 * 2 : value * 2) ? optionChange ? '#884EFB' : '#EEEEEE' : '#EEEEEE'}`
                            }}
                            key={index}
                            className='w-[3px] h-[3px] [@media_(min-height:1400px)]:h-[8px] [@media_(min-height:1400px)]:w-[8px] bg-[#EEEEEE] absolute top-2/4 -translate-y-1/2 rounded-[50%]'></div>
                    ))}
                    <div
                        className={`absolute w-[18px] h-[18px] [@media_(min-height:1400px)]:h-[30px] [@media_(min-height:1400px)]:w-[30px] ${optionChange ? 'bg-[#4A00E0]' : 'bg-[#999]'}  rounded-[50%] border-[2px] [@media_(min-height:1400px)]:border-[3px] border-[solid] border-[#fff] top-2/4 -translate-x-1/2 -translate-y-1/2 cursor-pointer [box-shadow:0_0_5px_2px_rgba(0,_0,_0,_0.1)]`} ref={knobRef}
                        style={{ left: `${position + 6}px` }}
                        onMouseDown={handleStart.bind(null, 'mouse')}
                        onTouchStart={handleStart.bind(null, 'touch')}
                    ></div>
                    <div className={`${optionChange ? 'bg-[#CDBCF2]' : 'bg-[#D9D9D9]'} h-full rounded-[12px]`} style={{
                        width: `${position + 6}px`,
                    }}></div>
                </div>
            </div>
            <div className={`${optionChange ? 'text-[#4A00E0]' : 'text-[#999999]'} [fontSize:var(--midFs)] w-[15%] text-center`}>{name === 'step' ? value + 10 : name === 'sharp' ? value - 5:value}</div>
        </div>
    );
})
Slider.displayName = 'Slider';

export default Option